import React from 'react';  
import {Link } from 'react-router-dom' 

import { useDispatch, useSelector } from 'react-redux'
import './PlanPattern.css' 
import { priceDish, Cals, findDeclension } from "../../../utils/utils.js";
import { days } from "../../../constants/constants.js";
import { useRef } from 'react';  

export function PlanPattern(props) {
  const item = props.item
  const { currentUser, rate, statusUser } = useSelector(state => state.currentUser)    
  const { date, breakfast, lunch, supper, dinner, snack, lateDinner } = item 
  const d = new Date(date);
  const n = d.getDay(); 
  const today = new Date();  
  const day = String(d.getDate()).padStart(2, '0'); // Получаем день и добавляем ноль перед числом, если нужно
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Получаем месяц и добавляем ноль, так как months начинаются с 0
  const formattedDate = `${day}/${month}`;
 const [dishes, setDishes] = React.useState([]) 
  const [calculation, setCalculation] = React.useState({}) 
  const [mainMeals, setMainMeals] = React.useState([])
  const dispatch = useDispatch();

 
  React.useEffect(()=> { 
    const newDishes = [
      { arr: breakfast ?? [], mealsRu: 'Завтрак', mealsEn: 'breakfast' },
      { arr: lunch ?? [], mealsRu: 'Ланч', mealsEn: 'lunch' },
      { arr: dinner ?? [], mealsRu: 'Обед', mealsEn: 'dinner' },
      { arr: snack ?? [], mealsRu: 'Полдник', mealsEn: 'snack' },
      { arr: supper ?? [], mealsRu: 'Ужин', mealsEn: 'supper' },
      { arr: lateDinner ?? [], mealsRu: 'Поздний ужин', mealsEn: 'lateDinner' },
    ];

    
    setDishes(newDishes)
    // Сразу фильтруем новые данные
    const filteredMainMeals = newDishes.filter(
      i => i.mealsEn === 'breakfast' || 
           i.mealsEn === 'dinner' || 
           i.mealsEn === 'supper' || 
           i.arr.length > 0
    );
    setMainMeals(filteredMainMeals);
   // setZeroMeals(newDishes.filter(i=> !i.arr || !filteredMainMeals.some(m => m.mealsEn === i.mealsEn)));
  }, [item])

   const formatDateTime = (dateString, includeTime = false) => {
    if (!dateString) return 'Нет даты';
    return new Date(dateString).toLocaleString('ru-RU', {
      dateStyle: 'short',
      timeStyle: includeTime ? 'short' : undefined
    });
  };
 
  console.log(item)
  return (
      <>
    <article className='menu-pattern flexColCenter'>
       <p className='font14EB'>Опция:{`${item.title ? item.title : 'не найден'}`}</p>
      <div className='menu-item__header flexRowSBS'>
        
      <div className='menu-item__header_icons'>
        <p className='menu-item__header_weekday font14EB'>{item ? days[n] : ''}</p>
        <p className='font14EB'>{`${item ?  formattedDate  : ''}`}</p>
        <p className='  font14EB'>Создан: {formatDateTime(item.createdAt)}</p> 
        <p className='  font14EB'>Обновлен: {formatDateTime(item.updatedAt)}</p>  
       </div>
     
      </div>
      <div className='menu-item__content'>
        {mainMeals.map((item, index)=> (
          <PatternMeals 
            items={item} 
            planId={props.item._id}
            key={index}
            
            />
        ))
        }
      
      </div>
      {item.nutritionTotals ?
      <div className='menu-item__footer'>
        <div className='menu-item__footer_price flexRowSB'>  
          <p className='font12Norm'>~{Math.ceil(calculation.price)} ₽</p>
        </div>
        <ul className= 'menu__block_cals menu__footer_cals'> 
          <Cals num={Math.ceil(item.nutritionTotals.protein)} name='Б' measure='г'  type='menu'/>
          <Cals num={Math.ceil(item.nutritionTotals.fats)} name='Ж' measure='г'  type='menu'/>
          <Cals num={Math.ceil(item.nutritionTotals.carb)} name='У' measure='г'  type='menu'/> 
          <Cals num={Math.ceil(item.nutritionTotals.calories)} measure='ккал' type='menu'/>
        </ul>
      </div>
      : 
      <div className='menu-item__footer'>
        <div className='menu-item__footer_price flexRowSB'> 
          <span className='gg-coins m-size'></span>
          <p>~ 0₽</p>
        </div>
        <ul className=' menu__block_cals menu__footer_cals'> 
          <Cals num='0 'name='Б' measure='г' type='footer'/>
          <Cals num='0' name='Ж' measure='г' type='footer'/>
          <Cals num='0' name='У' measure='г' type='footer'/> 
          <Cals num='0' measure='ккал' type='footer'/>
        </ul>
      </div>
    }
    </article>
    
    </> 
  ) 
}


const PatternMeals = ({
  items,  
  planId,  }) => {
  const {arr, mealsRu, mealsEn} = items    
  return (
    <div className='pattern-meals'> 
       { 
        arr.map((item, index) => (
          <MenuDish 
            item={item} 
            planId={planId}
            key={index}
            index={index}
            mealsRu={mealsRu}
            mealsEn={mealsEn}
            
          />
        )) }
    </div>
  )
}



const MenuDish = ({item, handleAddDish, 
  mealsRu, mealsEn, clickCreate, clickes, 
  handleChange, 
  hoax, 
  planId, 
  normalPlans, setHoax, index, 
  }) => { 
  console.log(item)
  const recipe= item && item.recipe
  const formatNumber = (num) => {
    const rounded = Math.round(num * 10) / 10; // Округляем до 1 знака
    return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(1);
  };
  return (
    <>
  { recipe ?
    <div className='pattern-dish flexRowSB'>
  <div className='menu-dish__image-block'>
   <img  className='menu-dish__image' src={recipe && recipe.image}/>  
   {index === 0 && 
      <span className='pattern-dish__assign font14Norm' > {mealsRu}
         
    </span>  
   }
  
    <div className='menu-dish__price font12Norm'>
     
 
    
    <span className='menu-dish__border font12Norm'></span> 
    <span className='  font12Norm'>~{Math.ceil(item.weight)}г {/* Math.round(price/item.servings)₽*/} </span>     
    </div>
    </div> 
  <div className='pattern-dish__content'>
    <div className='pattern-dish__heading'>
      <div className='df-c g10'>
       
      
      </div>
      <div className='pattern-dish__named'>
      <Link to={`/recipes/${recipe && recipe._id}`} target="_blank" className=" color-title" > <div className='menu-dish___title font18EB color-title'>{recipe && recipe.name}</div> </Link>
       
      </div>
    </div>
    <ul className='plan__cal menu__block_cals'> 
      <Cals num={formatNumber(item.protein)} name='Б' measure='г' type='menu'/>
      <Cals num={formatNumber(item.fats)}  name='Ж' measure='г' type='menu'/>
      <Cals num={formatNumber(item.carb)} name='У' measure='г' type='menu'/> 
      <Cals num={Math.ceil(item.cal)} measure='ккал' type='menu'/>
    </ul>
  </div> 
</div>
:  <div className='pattern-dish__named'> NOne
         
      </div>
  }
 </>

  
  )
}
